import {
  Stepper,
  Button,
  TextInput,
  Checkbox,
  Flex,
  Select,
  PasswordInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  creationNotification,
  updateNotification,
} from "../utils/useNotification";
import { validateRequired } from "../utils/validations";
import {
  createCompany,
  getCompanyById,
  getCompanyPhoto,
  updateCompanyById,
  uploadCompanyPhoto,
} from "../api/companyApi";
import PhotoUploadInput from "../components/common/PhotoUploadInput";
import Container from "../components/common/Container";
import { createHrUser } from "../api/hrUserApi";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";

const NewCompany = () => {
  const navigate = useNavigate();
  const [company, setCompany] = useState<any>();

  const { id }: any = useParams();

  const isEditMode = Boolean(id);

  const getCompanyDetail = async () => {
    try {
      const { data }: any = await getCompanyById(id);

      const companyData = data?.company;

      if (companyData) {
        setCompany(companyData);

        companyForm.setValues({
          name: companyData.name || "",
          code: companyData.code || "",
          address: companyData.address || "",
          taxNumber: companyData.taxNumber || "",
          note: companyData.note || "",
          taxOffice: companyData.taxOffice || "",
        });

        setModules({
          isCalendarAvailable:
            companyData.modules?.isCalendarAvailable || false,
          isGeneralSettingsWorkHoursAvailable:
            companyData.modules?.isGeneralSettingsWorkHoursAvailable || false,
          isDepartmentWorkHoursAvailable:
            companyData.modules?.isDepartmentWorkHoursAvailable || false,
          isApplicantAvailable:
            companyData.modules?.isApplicantAvailable || false,
          isDocumentUploadAvailable:
            companyData.modules?.isDocumentUploadAvailable || false,
          // isSkillFieldAvailable:
          //   companyData.modules?.isSkillFieldAvailable || false,
        });
      }

      for (const { type } of imageTypes) {
        try {
          const res: any = await getCompanyPhoto(companyData._id, type);

          if (res?.data && res.status === 200) {
            const imageBlob = res.data;
            const imageURL = URL.createObjectURL(imageBlob);

            setPreviews((prev) => ({
              ...prev,
              [type]: imageURL,
            }));
          }
        } catch (error) {
          console.warn(`${type} fotoğrafı alınamadı:`, error);
        }
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  useEffect(() => {
    if (id) getCompanyDetail();
  }, [id]);

  const [activeStep, setActiveStep] = useState(0);

  const [photos, setPhotos] = useState<{ [key: string]: File | null }>({
    hr: null,
    mobile: null,
    terminal: null,
  });

  const [previews, setPreviews] = useState<{ [key: string]: string | null }>({
    hr: null,
    mobile: null,
    terminal: null,
  });

  const [overlayVisible, setOverlayVisible] = useState<{
    [key: string]: boolean;
  }>({
    hr: false,
    mobile: false,
    terminal: false,
  });

  const [loadingState, setLoadingState] = useState<{ [key: string]: boolean }>({
    hr: false,
    mobile: false,
    terminal: false,
  });

  const imageTypes = [
    { type: "hr", label: "Şirket Logosu Yükle" },
    { type: "mobile", label: "Mobil Logo Yükle" },
    { type: "terminal", label: "Terminal Logo Yükle" },
  ];

  const companyForm = useForm({
    initialValues: {
      name: "",
      code: "",
      address: "",
      taxNumber: "",
      note: "",
      taxOffice: "",
    },
    validate: {
      name: validateRequired,
      taxNumber: validateRequired,
      code: validateRequired,
      //note: validateRequired,
      address: validateRequired,
      taxOffice: validateRequired,
    },
  });

  const [modules, setModules] = useState<{
    [key: string]: boolean;
  }>({
    isCalendarAvailable: false,
    isGeneralSettingsWorkHoursAvailable: false,
    isDepartmentWorkHoursAvailable: false,
    isDocumentUploadAvailable: false,
    isApplicantAvailable: false,
    // isSkillFieldAvailable: false,
  });

  const toggleModule = (key: string) => {
    setModules((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const userForm = useForm({
    initialValues: {
      name: "",
      phone: "",
      privilege: "",
      password: "",
    },
    validate: {
      name: validateRequired,
      phone: (val) =>
        !val
          ? "Bu alan zorunludur"
          : val.length !== 11
          ? "Telefon numarası 11 haneli olmalıdır"
          : null,
      privilege: validateRequired,
      password: (val) =>
        val.length >= 6 ? null : "Şifre en az 6 karakter olmalı",
    },
  });

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setPhotos((prev) => ({ ...prev, [type]: file }));
      const previewURL = URL.createObjectURL(file);
      setPreviews((prev) => ({ ...prev, [type]: previewURL }));
    }
  };

  const uploadAllImages = async (companyId: string) => {
    try {
      setLoadingState((prev) => ({
        ...prev,
        hr: !!photos.hr,
        mobile: !!photos.mobile,
        terminal: !!photos.terminal,
      }));

      for (const type of Object.keys(photos)) {
        const photo = photos[type];
        if (!photo) continue;

        const formData = new FormData();
        formData.append("companyId", companyId || "");
        formData.append("file", photo);

        try {
          await uploadCompanyPhoto(formData, type);
        } catch (error) {
          console.error(`Upload error for ${type}:`, error);
        }
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    } finally {
      setLoadingState({ hr: false, mobile: false, terminal: false });
    }
  };

  const handleFinalSubmit = async () => {
  const preparedValues = {
    ...companyForm.values,
    note: companyForm.values.note || "", 
  };

  if (isEditMode) {
    try {
      const { data }: any = await updateCompanyById({
        updates: { ...preparedValues, modules: modules },
        companyId: id,
      });
      updateNotification(data?.success);
      await uploadAllImages(id);
      navigate("/companies");
    } catch (error: any) {
      console.error("Güncelleme Hatası:", error);
    }
  } else {
    try {
      const { data }: any = await createCompany({
        values: {
          ...preparedValues,
          modules: modules,
          entryBuffer: 0,
          exitBuffer: 0,
          workHours: {},
        },
      });

      if (data?.companyId) {
        await createHrUser({
          ...userForm.values,
          companyId: data.companyId as string,
        });
        
        creationNotification("Şirket", data?.success);
        await uploadAllImages(data.companyId);
        navigate("/companies");
      }
    } catch (error) {
      console.error("Error creating company:", error);
    }
  }
};

  return (
    <Container>
      <ActionIcon 
        variant="subtle" 
        color="#5c26ff" 
        size={44} 
        onClick={() => navigate("/companies")} 
      >
        <IconArrowLeft  size={28} />
      </ActionIcon>
      <Stepper
        color="#5c26ffff"
        active={activeStep}
        allowNextStepsSelect={false}
        onStepClick={setActiveStep}
      >
        <Stepper.Step label="Şirket Bilgisi">
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
            onSubmit={companyForm.onSubmit(() => {
              setActiveStep(1);
            })}
          >
            <Flex direction={"column"}>
              <TextInput
                label="Şirket Adı"
                {...companyForm.getInputProps("name")}
              />
              <TextInput
                label="Şirket Kodu"
                {...companyForm.getInputProps("code")}
                value={companyForm.values.code.toUpperCase().replace(/\s/g, "")}
                onChange={(e) => {
                  const upperNoSpaces = e.currentTarget.value
                    .toUpperCase()
                    .replace(/\s/g, "");
                  companyForm.setFieldValue("code", upperNoSpaces);
                }}
              />
              <TextInput
                label="Şirket Adresi"
                {...companyForm.getInputProps("address")}
              />
              <TextInput
                label="Vergi Numarası"
                {...companyForm.getInputProps("taxNumber")}
              />
              <TextInput
                label="Vergi Dairesi"
                {...companyForm.getInputProps("taxOffice")}
              />
              <TextInput
                label="Şirket Notu"
                {...companyForm.getInputProps("note")}
                withAsterisk={false} 
              />
            </Flex>

            <Flex justify="space-between" gap={40} wrap="wrap">
              {imageTypes.map(({ type, label }) => (
                <PhotoUploadInput
                  key={type}
                  type={type}
                  label={label}
                  photo={photos[type]}
                  preview={previews[type]}
                  overlayVisible={overlayVisible[type]}
                  loading={loadingState[type]}
                  onFileChange={handleFileChange}
                  setOverlayVisible={(visible) =>
                    setOverlayVisible((prev) => ({
                      ...prev,
                      [type]: visible,
                    }))
                  }
                />
              ))}
            </Flex>
            <Flex justify={"end"}>
              <Button color="#5c26ffff" type="submit">
                İleri
              </Button>
            </Flex>
          </form>
        </Stepper.Step>

        <Stepper.Step label="Modüller">
          <Flex mih={"76.2vh"} direction={"column"} justify={"space-between"}>
            <Flex mt={15} direction={"column"} gap={15}>
              <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="Takvim"
                checked={modules.isCalendarAvailable}
                onChange={() => toggleModule("isCalendarAvailable")}
              />
              <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="Genel Ayarlar Mesai Saati"
                checked={modules.isGeneralSettingsWorkHoursAvailable}
                onChange={() =>
                  toggleModule("isGeneralSettingsWorkHoursAvailable")
                }
              />
              <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="Departman Ayarlar Mesai Saati"
                checked={modules.isDepartmentWorkHoursAvailable}
                onChange={() => toggleModule("isDepartmentWorkHoursAvailable")}
              />
              <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="Döküman/Belge Yükleme Modülü"
                checked={modules.isDocumentUploadAvailable}
                onChange={() => toggleModule("isDocumentUploadAvailable")}
              />
              <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="CV/Başvuran Modülü"
                checked={modules.isApplicantAvailable}
                onChange={() => toggleModule("isApplicantAvailable")}
              />
              {/* <Checkbox
                color="#5c26ffff"
                labelPosition="left"
                label="Yetenek Ayarları"
                checked={modules.isSkillFieldAvailable}
                onChange={() => toggleModule("isSkillFieldAvailable")}
              /> */}
            </Flex>

            <Flex justify={"space-between"}>
              <Button variant="default" onClick={() => setActiveStep(0)}>
                Geri
              </Button>
              <Button
                color="#5c26ffff"
                onClick={() => {
                  !isEditMode ? setActiveStep(2) : handleFinalSubmit();
                }}
              >
                {isEditMode ? "Güncelle" : "İleri"}
              </Button>
            </Flex>
          </Flex>
        </Stepper.Step>

        {!isEditMode && (
          <Stepper.Step label="İlk Kullanıcı">
            <form onSubmit={userForm.onSubmit(handleFinalSubmit)}>
              <Flex
                direction={"column"}
                justify={"space-between"}
                mih={"76.2vh"}
              >
                <Flex direction={"column"}>
                  <TextInput
                    label="Ad Soyad"
                    placeholder="Ad Soyad Giriniz"
                    {...userForm.getInputProps("name")}
                  />
                  <TextInput
                    label="Telefon"
                    placeholder="Telefon Giriniz"
                    maxLength={11} 
                    {...userForm.getInputProps("phone")}
                  />
                  <Select
                    label="Yetki"
                    placeholder="Yetki Seçiniz"
                    data={[
                      { value: "admin", label: "Admin" },
                      { value: "user", label: "User" },
                    ]}
                    {...userForm.getInputProps("privilege")}
                  />
                  <PasswordInput
                    label="Şifre"
                    placeholder="Şifre Giriniz"
                    type="password"
                    {...userForm.getInputProps("password")}
                  />
                </Flex>
                <Flex justify={"space-between"}>
                  <Button variant="default" onClick={() => setActiveStep(1)}>
                    Geri
                  </Button>
                  <Button type="submit" color="#5c26ffff">
                    Kaydet ve Bitir
                  </Button>
                </Flex>
              </Flex>
            </form>
          </Stepper.Step>
        )}
      </Stepper>
    </Container>
  );
};

export default NewCompany;
